/** Nom affiché : nom + prénom (anciens clients) ou nom seul si tout est dans nom. */
export function getClientNomComplet(client) {
    if (!client) return '';
    return `${client.nom || ''} ${client.prenom || ''}`.trim();
}

/** Enregistrement BDD : tout le libellé saisi dans nom (espaces autorisés). */
export function nomCompletToDbFields(nomComplet) {
    const trimmed = String(nomComplet || '').trim();
    return { nom: trimmed, prenom: '' };
}
